import Sortable from 'sortablejs';

const BASE_SELECTOR: string = '[data-reorder]';

export class ReorderUI {
    constructor(private $base: JQuery<HTMLElement>) {
        Sortable.create(this.$base.find('.order-list')[0], {
            ghostClass: 'table__row--highlighted',
            easing: "cubic-bezier(1, 0, 0, 1)",
            animation: 50
        });
    }
}

export function createReorderInstances(): ReorderUI[] {
    const instances: ReorderUI[] = [];
    $(BASE_SELECTOR).each((index, element) => {
        instances.push(new ReorderUI($(element)));
    });
    
    return instances;
}